import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition,
  IcecontrolPermission
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { reportindex } from 'projects/icemedx-lib/src/models/reports/reportindex';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { IceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { IBaseListView } from '../../../../icemedx-lib/src/components/baseview.component';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { otheritemsindex } from '../../../../icemedx-lib/src/models/otheritems/otheritemsindex';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { otheritems } from '../../../../icemedx-lib/src/models/otheritems/otheritems';
import { VendorService } from '../../../../icemedx-lib/src/services/vendor/vendor.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { PharmacyService } from '../../../../icemedx-lib/src/services/pharmacy/pharmacy.service';
import { PayerService } from '../../../../icemedx-lib/src/services/payer/payer.service';
import { basecode } from '../../../../icemedx-lib/src/models/ehr/subs/basecode';
import { superbillchargesindex } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillchargesindex';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { medicalservicereference } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservicereference';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { otheritemsreceiving } from '../../../../icemedx-lib/src/models/otheritems/otheritemsreceiving';
import { purchasedelivery } from '../../../../icemedx-lib/src/models/accounting/medservice/purchasedelivery';
import { purchaseindex } from '../../../../icemedx-lib/src/models/accounting/medservice/purchaseindex';
import { superbillindex } from '../../../../icemedx-lib/src/models/accounting/superbillindex';

const BillingActionDomainType = "BillingActionDomainType";

@Component({
  selector: 'app-billingtemplates',
  templateUrl: './billingtemplates.component.html',
  styleUrls: ['./billingtemplates.component.scss'],
  providers: [AppService, IceNavService]
})
export class BillingTemplatesComponent implements OnInit, IBaseListView {
  // data members
  templatesDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);

  // member settings
  billingTemplateViewSettings: IcepanelcontainerSettings = null;
  billingPermission: IcecontrolPermission = null;

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private domainSvc: DomainService,
    private accSvc: AccountingService,
    private vendorSvc: VendorService,
    private patientSvc: PatientService,
    private proSvc: ProviderService,
    private pharmSvc: PharmacyService,
    private payerSvc: PayerService,
    private medCodeSvc: MedicalcodesService,
    private router: Router,
    private changeDetectorRefs: ChangeDetectorRef) {

    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Billing Template", {}, true, "");

    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;
    this.billingPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufSuperBill, feaAccess);

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
    }

    this.billingTemplateViewSettings = this.viewSetup([]);
  }

  getBreadcrumbs(): any {
    return this.appSvc.getBreadcrumbs();
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  viewSetup(dat: IceEntity[]): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = null;
    try {
      let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;

      if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
        this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
        return null;
      }
      if (dat == null) {
        return null;
      }

      let controls: IcecontrolSettings[] = [];
      let headerControls: IcecontrolSettings[] = [];

      let resultsTable = new IcemattableSettings(
        "TemplateTable",
        [
          new iceColumnDefinition("name", "Name of Template", false, false,
            new IcecontrolSettings("icelabel", { width: "200px" }, null, null)),
          new iceColumnDefinition("taxonomy_code", "Taxonomy", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "Stock No.", width: "100px" }, null, null)),
          new iceColumnDefinition("account_type", "Type of Template", false, false,
            new IcecontrolSettings("icelabel", { placeholder: "SKU No.", width: "75px" }, null, null)),
          new iceColumnDefinition("superbill_key", "superbill_key", true),
          new iceColumnDefinition("QuickActions", "", false, false),
        ],
        this.templatesDataSource,
        [],
        false,
        null,
        true
      ).showAddButton(true);

      let groups: IcepanelgroupSettings[] = [
        new IcepanelgroupSettings(null, [resultsTable])
      ];

      let sections: IcepanelsectionSettings[] = [
        new IcepanelsectionSettings("TemplateListSection", { class: [""], styles: { width: "100%" } }, groups, controls, []),
      ];

      let panel = new IcepanelSettings("TemplateListPanel", Iceutility.guid(false), "Templates", "", sections, headerControls)
        .enableForm();

      let panels: IcepanelSettings[] = [
        panel,
      ];

      let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
      setup = new IcepanelcontainerSettings("TemplateListViewContainer", panelrows);

      this.accSvc.getBillTemplates(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), IceTypes.ACCOUNT_TYPE.actNone, "").subscribe(
        data => {
          if (data == null || data.length == 0) return;

          let datasrc = [];
          let templates: superbillindex[] = <superbillindex[]>data;
          for (let i = 0; i < templates.length; i++) {
            let tempidx: superbillindex = templates[i];
            if (tempidx == null) continue;

            let obj = {
              name: tempidx.name,
              account_type: DomainService.getDomainType(Iceutility.toDouble(tempidx.account_type)),
              taxonomy_code: tempidx.taxonomy_code,
              superbill_key: tempidx.superbill_key,
            };
            datasrc.push(obj);
          }

          this.templatesDataSource.data = datasrc;
        }, error => {
          console.log(JSON.stringify(this.medCodeSvc.getLastErrors()));
        });

    }
    catch (e) {
      console.log(e);
    }
    return setup;
  }

  /////////////////////////////////////
  // Events

  onButtonClick(event) {
    /*
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        case BillingActionDomainItemSubmit: {
          let itemEntryFrm = this.ctrlBillingDomainItemEntryCtrl.getFormControl();
          if (itemEntryFrm != null)
            this.processItemEntry(itemEntryFrm.value, "");
          break;
        }
        default: {
          // Add New Item to DB
          if (this.appSvc.processEditPanelSectionButtons(this.sectionTagNewItem, event.buttonSettings.id)) {
            let item: otheritems = new otheritems(this.newItem);
            if (this.newItem != null && this.newItem["code_object"] != null && this.newItem["code_object"].length > 0) {
              try {
                let codeObj = JSON.parse(this.newItem["code_object"]);
                if (codeObj != null && codeObj.length > 0) {
                  this.newItem.code = item.code = codeObj[0].value;
                  this.newItem.code_txt = item.code_txt = codeObj[0].name;

                }
              }
              catch (e) {
                console.log(e);
              }
            }

            let codeQuaList = MedicalcodesService.getMedicalCodeTypeList().filter(opt => item.code_list_qualifier_code == opt.name);
            if (codeQuaList.length > 0) {
              item.code_list_qualifier_code = codeQuaList[0].value;
            }

            let unitList = this.invUnitCtrl.getOptions().filter(opt => item.unit_type == opt.name);
            if (unitList.length > 0) {
              item.unit_type = unitList[0].value;
            }

            this.accSvc.addOtherItem(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), item).subscribe(
              data => {
                if (data == null || data.length == 0) return;
                if (this.newItem == null) return;

                if (this.resultsDataSource.data == null) this.resultsDataSource.data = [];

                let svrItem: otheritems = <otheritems>data[0];
                if (svrItem == null) return;

                this.newItem.other_items_key = svrItem.other_items_key;
                this.resultsDataSource.data.push(this.newItem)
                this.resultsDataSource.data = this.resultsDataSource.data;

                // Reset;
                this.newItem = null;
              },
              error => {
                // To do, log error
              });            
          }
          break;
        }
      }
    }
    */
  }

  public onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        case "TemplateTable": {
          this.router.navigate([this.navSvc.buildRoute("accounting/billtemplate/0", false)]);
          break;
        }
      }
    }
  }

  onMatGridRowClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }
    this.router.navigate([this.navSvc.buildRoute("accounting/billtemplate/" + event["rowData"]["superbill_key"], false)]);
  }

  onMatGridRowActionClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }

    /*
    let actionType = this.getBillingAction();

    if (event.actionItem == null) return;
    if (itemQuickActionAdd.value == event.actionItem.value) {
      if (actionType == OrderActionType.oatCheckout) {
        let item = <otheritemsindex>event["rowData"];
        if (item == null) {
          // To do log error
          return;
        }
        this.processItemEntry(item.item_stock_num, item.other_items_key);
      }
      else {
        let recv = <otheritemsreceiving>event["rowData"];
        if (recv == null) {
          // To do log error
          return;
        }
        this.processItemEntry("", recv.other_items_key);
      }
    }
    else if (itemQuickActionEdit.value == event.actionItem.value) {
      let item = <otheritemsindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
      this.router.navigate([this.navSvc.buildRoute("accounting/inventory/item/" + item.other_items_key, false)]);
    }
    else if (ItemActionType.oatRemoveFromOrder == event.actionItem.value) {
      let ordObj = this.getBillingOrder();
      let billkey = ""
      if (ordObj != null && ordObj.length > 0)
        billkey = ordObj[0].value;

      if (actionType == OrderActionType.oatCheckout) {
        let item = <otheritemsindex>event["rowData"];
        if (item == null) {
          // To do log error
          return;
        }
        let itemParams = {
          itemkey: item["medical_service_key"],
        };

        this.accSvc.billServiceScanItemRemove(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, itemParams).subscribe(
          data => {
            this.orderItemsDataSource.data = this.orderItemsDataSource.data.filter(msv => msv.medical_service_key != itemParams.itemkey);
            this.changeDetectorRefs.detectChanges();
          },
          error => {
            // To do, log error
          });
      }
      else {
        let recv = <otheritemsreceiving>event["rowData"];
        if (recv == null) {
          // To do log error
          return;
        }
        let recvParams = {
          recvkey: recv["other_items_receiving_key"],
        };

        this.accSvc.itemReceivingScanItemRemove(this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType(), billkey, recvParams).subscribe(
          data => {
            this.purchaseItemsDataSource.data = this.purchaseItemsDataSource.data.filter(recv => recv.other_items_receiving_key != recvParams.recvkey);
            this.changeDetectorRefs.detectChanges();
          },
          error => {
            // To do, log error
          });
      }
    }
    */
  }
}
